import { render, staticRenderFns } from "./EventPopularServicesList.vue?vue&type=template&id=cad40d10"
import script from "./EventPopularServicesList.vue?vue&type=script&lang=js"
export * from "./EventPopularServicesList.vue?vue&type=script&lang=js"
import style0 from "./EventPopularServicesList.vue?vue&type=style&index=0&id=cad40d10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports